<template>
  <div class="tools">
    <slot />
  </div>
</template>

<style lang="scss">
.tools {
  width: 100%;
  padding: var(--gap-section);
  padding-top: var(--gap);
  background-color: var(--surface-content);
}
</style>
